<div class="cookie-panel ev-card" data-testid="cookie-panel-container">
  <div class="cookie-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"/>
      <path d="M8.5 8.5v.01"/><path d="M16 15.5v.01"/><path d="M12 12v.01"/>
      <path d="M11 17v.01"/><path d="M7 14v.01"/>
    </svg>
  </div>
  <p class="cookie-text">
    {{ languageService.languageJSON.App_Cookies_Analytics }} <a class="cookie-link" data-testid="cookie-panel-privacy-link" (click)="openPrivacyPolicy()">{{ languageService.languageJSON.App_Cookies_Link }}</a>
  </p>
  <div class="cookie-buttons">
    <!-- Same styling on purpose: rejecting must be as easy as accepting. -->
    <button class="ev-button primary cookie-btn" data-testid="cookie-panel-reject-btn" (click)="reject()">
      {{ languageService.languageJSON.Global_Reject }}
    </button>
    <button class="ev-button primary cookie-btn" data-testid="cookie-panel-accept-btn" (click)="accept()">
      {{ languageService.languageJSON.Global_Accept }}
    </button>
  </div>
</div>
